/* eslint-disable no-unused-vars */
// eslint-disable-next-line import/no-cycle
import feathersClient from '../../feathers-client';

const defaultUsersPagination = {
	total: 100,
	$skip: 0,
	$limit: 6,
};

const defaultUsersFilter = {
	$skip: defaultUsersPagination.$skip,
	$limit: defaultUsersPagination.$limit,
};

export default {
	state: {
		users: [],
		usersFilter: defaultUsersFilter,
		usersPagination: defaultUsersPagination,
		currentUserRoleType: '', // roleLevel 'Admin,Manger/superAdmin
		currentUserRoleLevel: '', // roleType (name of role)
		userPersonas: [],
		userEndorsementHistory: [],
		userCapabilityEndorsementHistory: '',
		originalUserPersonas: [],
		usersPage: 1,
		syncUserData: {
			staffNo: '',
			optimaData: null,
			userData: null,
		},
	},
	getters: {
		usersPage: (state) => {
			const { $limit, $skip } = state.usersPagination;
			return $skip / $limit + 1;
		},
		currentUserRoleType: (state) => state.currentUserRoleType,
		currentUserRoleLevel: (state) => state.currentUserRoleLevel,
	},
	mutations: {
		SET_USERS: (state, users) => { state.users = users; },
		SET_USERS_PAGINATION: (state, data) => { state.usersPagination = { ...state.usersPagination, ...data }; },
		SET_USERS_FILTER: (state, filter) => { state.usersFilter = { ...state.usersFilter, ...filter }; },
		SET_DEFAULT_USERS_FILTER: (state, filter) => { state.usersFilter = { ...filter, ...defaultUsersFilter }; },
		SET_CURRENT_USER_ROLE_LEVEL: (state, data) => { state.currentUserRoleLevel = data; },
		SET_CURRENT_USER_ROLE_TYPE: (state, data) => { state.currentUserRoleType = data; },
		SET_USER_PERSONAS: (state, userPersonas) => { state.userPersonas = userPersonas; },
		SET_USER_ENDORSEMENT_DATA: (state, userEndorsementHistory) => { state.userEndorsementHistory = userEndorsementHistory; },
		SET_USER_ENDORSEMENT_CAPABILITY_DATA: (state, userCapabilityEndorsementHistory) => { state.userCapabilityEndorsementHistory = userCapabilityEndorsementHistory; },
		SET_ORIGINAL_USER_PERSONAS: (state, originalUserPersonas) => { state.originalUserPersonas = originalUserPersonas; },
		SET_SYNC_USER_DATA(state, { staffNo, optimaData, userData }) {
			state.syncUserData = {
				staffNo,
				optimaData,
				userData,
			};
		},
		CLEAR_SYNC_USER_DATA(state) {
			state.syncUserData = {
				staffNo: '',
				optimaData: null,
				userData: null,
			};
		},
	},
	actions: {
		setUsersFilter: ({ commit }, filter) => {
			commit('SET_USERS_FILTER', filter);
		},
		setDefaultUsersFilter: ({ commit }, filter) => {
			commit('SET_DEFAULT_USERS_FILTER', filter);
		},
		setUsersPage: ({ commit, state }, page) => {
			const $skip = (page - 1) * state.usersPagination.$limit;
			commit('SET_USERS_PAGINATION', { $skip });
			commit('SET_USERS_FILTER', { $skip });
		},
		getUsers: async ({ commit, rootGetters }, filter) => {
			const results = await feathersClient.service('/api/v3/get-trust-users').find({
				query: {
					fields: ['optimaStaffNumber'],
					$getUsersOfTrust: true,
					$role: rootGetters.currentUserRole,
					...filter,
				},
			});
			commit('SET_USERS', results.data);
			const totalCount = results.total;
			commit('SET_USERS_PAGINATION', { total: totalCount });
			return results;
		},
		getUserPermissionsOfTrust: async ({ rootGetters }, query) => {
			const url = '/api/v3/user-permissions-of-trust'; // trust-admin
			const results = await feathersClient.service(url).find({ query: { $role: rootGetters.currentUserRole, ...query } });
			return results;
		},
		getSelectedUserById: async (context, id) => {
			const results = await feathersClient.service('/api/v3/users').get(id);
			return results;
		},
		getUserApprovedLevelsHierarchy: async({ rootGetters }) => {
			const results = await feathersClient.service('/api/v3/user-roles').find({
				query: {
					$getUserAccessHierarchy: true,
					$role: rootGetters.currentUserRole,
				},
			});
			return results;
		},
		createUser: async (context, user) => {
			const results = await feathersClient.service('/api/v3/users').create(user, {
			});
			return results;
		},
		updateUserDetails: async ({ rootGetters }, account) => {
			const results = await feathersClient.service('/api/v3/users').patch(account.id, {
				...account,
				email: account.email.toLowerCase(),
			}, {
				query: {
					$role: rootGetters.currentUserRole,
				},
			});
			return results;
		},
		updateRequestedUserDetails: async({ rootGetters }, account) => {
			const results = await feathersClient.service('/api/v3/users').patch(account.id, {
				...account,
				email: account.email.toLowerCase(),
			}, {
				query: {
					$isNotApprovedUser: true,
					$role: rootGetters.currentUserRole,
			 },
			});
			return results;
		},
		updateRequestedUserDatas: async({ rootGetters }, filter) => {
			const results = await feathersClient.service('/api/v3/users').patch(filter.id, {
				...filter,
				
			}, {
				query: {
					
					$role: rootGetters.currentUserRole,
			 },
			});
			return results;
		},
		loadUserDetailsById: async ({ rootGetters }, id) => {
			const url = '/api/v3/users';
			
			const results = await feathersClient.service(url).get(id, { query: { fields: ['userSkills', 'endorsmentHistory','userRoles','preferredCarelocations','contractedHours', 'postings'] } });
			
			return results;
		},
		loadUserDetailsByIdWithFeatureCheck: async ({ rootGetters }, id) => {
			const url = '/api/v3/users';
			
			const results = await feathersClient.service(url).get(id, { query: { fields: ['userSkills', 'endorsmentHistory','userRoles','preferredCarelocations','contractedHours', 'postings'], featureCheck: true, trustId: rootGetters.currentTrustId } });
			return results;
		},
		verifyChangedEmail: async ({ rootGetters }, token) => {
			const results = await feathersClient.service('/api/v3/update-email').patch(null, { status: 'VERIFIED' }, { query: { token: token, $sort: { createdAt: -1 }, status: 'PENDING' } });
			return results;
		},
		loadRejectedUserOfTrust: async ({ commit, rootGetters }, filter) => {
			const results = await feathersClient.service('/api/v3/get-trust-users').find({
				query: {
					$getRejectedUsers: true,
					$role: rootGetters.currentUserRole,
					...filter,
					$sort: { firstname: 1 },
				},

			});
			
			commit('SET_USERS', results.data);
			const totalCount = results.total;

			commit('SET_USERS_PAGINATION', { total: totalCount });
			return results.data;
		},
		forgotPassword: async ({ rootGetters }, data) => {
			const url = '/api/v3/forgot-password';
			const results = await feathersClient.service(url).create(data);
			return results;
		},
		resetPassword: async ({ rootGetters }, data) => {
			const url = '/api/v3/authmanagement';
			const results = await feathersClient.service(url).create(data);
			return results;
		},
		getUserMonthlyShiftDetails: async({ rootGetters }, userId) => {
			const result = await feathersClient.service('api/v3/get-staff-monthly-applications').find({
				query: {
					$role: rootGetters.currentUserRole,
					userId: userId,
				},
			});
			return result;
		},
		getbaseHospitalDetails: async({ rootGetters }, id) => {
			const result = await feathersClient.service('api/v3/institutions').get(id);
			return result;
		},

		updateContractedWorkHours: async({rootGetters,commit},data) => {
			const results = await feathersClient.service('/api/v3/trust-staff-contracted-hours').patch(data.id, data,{
				query:{
					$role: rootGetters.currentUserRole,
				}
			});
			return results;
		},
		syncBankshiftUsersWithOptima: async ({ rootGetters }, filter) => {
			const url = '/api/v3/sync-bankshift-users-to-optima'; // trust-admin
			const results = await feathersClient.service(url).create({}, { query: { $role: rootGetters.currentUserRole, ...filter } });
			return results;
		},
		onBoardOptimaUsers: async ({ rootGetters }, onBoardData) => {
			const url = '/api/v3/sync-optima-users-to-bankshift'; // trust-admin
			const results = await feathersClient.service(url).create(onBoardData.data, { query: { $role: rootGetters.currentUserRole, ...onBoardData.filter } });
			return results;
		},
		getUserPersonas: async ({ commit, rootGetters }, filter) => {
			const url = '/api/v3/user-personas';
			const results = await feathersClient.service(url).find({ query: { $role: rootGetters.currentUserRole, fields: ['endorsementRequestHistory'], ...filter } });
			commit('SET_USER_PERSONAS', results);
			commit('SET_ORIGINAL_USER_PERSONAS', _.cloneDeep(results));
			return results;
		},
		userEndorsementData({ commit }, userData) {
			commit('SET_USER_ENDORSEMENT_DATA', userData);
		  },
		  userEndorsementCapabilityData({ commit }, userCapabilityData) {
			commit('SET_USER_ENDORSEMENT_CAPABILITY_DATA', userCapabilityData);
		  },
		getTrustUserByStaffNumber: async ({ rootGetters }, staffNumber) => {
			const results = await feathersClient.service('/api/v3/get-trust-users').find({
				query: {
					staffNumber,
					$optimaUserDetails: true,
					$role: rootGetters.currentUserRole,
				},
			});
			
			return results;
		},
		getNurseUserByStaffNumber: async ({ rootGetters }, staffNumber) => {
			const results = await feathersClient.service('/api/v3/get-nurse-users').find({
				query: {
					staffNumber,
					$optimaUserDetails: true,
					$role: rootGetters.currentUserRole,
				},
			});
			return results;
		},
		setSyncUserData: ({ commit }, data) => {
			commit('SET_SYNC_USER_DATA', data);
		},
		syncBankshiftUsersToOptima: async ({ rootGetters }, data) => {
			try {
				const response = await feathersClient.service('/api/v3/sync-bankshift-users-to-optima').create({
					userId: data.userId,
					trustId: data.trustId,
					forenames: data?.forenames,
					surname: data?.surname,
					dateOfBirth: data?.dateOfBirth,
					assignmentNumber: data?.assignmentNumber,
					startsOn: data?.startsOn,
					endsOn: data?.endsOn,
					hireDate: data?.hireDate,
					sendOnboardMail: false,
					optimaWorkerId: data?.workerId,
					staffNumber: data?.staffNumber,
					nationalInsuranceNumber: data?.nationalInsuranceNumber,
					additionalId: data?.additionalId,
					email: data?.contact?.email,
					gradeId: data?.gradeId,
				}, {
					query: {
						$role: rootGetters.currentUserRole,
					},
				});
				return response;
			} catch (error) {
				console.error('Error syncing user:', error);
			}
		},
		deleteUser: async ({ rootGetters }, userId) => {
			try {
				const results = await feathersClient.service('/api/v3/users').remove(userId, {
					query: {
						$role: rootGetters.currentUserRole,
					},
				});
				return results;
			} catch (error) {
				 console.error('Error deleting user:', error);
				 throw error;
			}
		},
	},
};
